export const handleResetField = (e: any, f: any, i: any) => {
  f.change(i.name, "");
};
